<template>
  <filter-form v-bind="state.filter.schema" />
</template>

<script>
import FilterForm from '@/components/filter-form/filter-form';

export default {
  name: 'users-filter',
  components: { FilterForm },
  computed: {
    state: function () {
      return this.$store.state.users;
    }
  }
};
</script>
